module.exports = __webpack_public_path__ + "img/rankingHead.e272ba23.png";